import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          customerId: Yup.string(),
                                          description: Yup.string(),
                                          paymentMethod: Yup.string(),
                                          usage: Yup.string(),
                                      });
